module.exports = __webpack_public_path__ + "static/billboard-c6c343adc16b41e40bfac186a1c49827.png";